import axios from "config/axios";

const ENDPOINT = "/rel-issue-template-custom-fields";

export const createRelIssueTemplateCustomFields = (params: any) =>
  axios.post(`${ENDPOINT}/create`, { ...params });
